<div class="overlay" (click)="close()">
  <div class="modal" (click)="$event.stopPropagation()">
    <h2>Excluir Pasta</h2>

    <p>Você tem certeza que quer excluir a pasta <strong>{{ folderName }}</strong>?</p>
    <p class="warning">Esta ação não pode ser desfeita e excluirá todos os decks dentro dela.</p>

    <div class="modal-actions">
      <!-- Se tiver uma classe secundária para botões de cancelar, use-a -->
      <button class="but btn" (click)="close()">Cancelar</button>
      <button class="but btn ex" (click)="confirmDelete()">Excluir</button>
    </div>
  </div>
</div>